import React from "react";

import css from "../OrgChart.module.scss";
import type { LayoutNode } from "../layout";

export function EdgeRenderer({
	edges,
	positions,
	offsetX,
	offsetY,
	contentWidth,
	contentHeight,
}: {
	edges: Array<{ source: string; target: string }>;
	positions: Map<string, LayoutNode>;
	offsetX: number;
	offsetY: number;
	contentWidth: number;
	contentHeight: number;
}) {
	return (
		<svg className={css.edges} width={contentWidth} height={contentHeight}>
			{edges.map(({ source, target }) => {
				const sourceNode = positions.get(source);
				const targetNode = positions.get(target);
				if (!sourceNode || !targetNode) return null;
				const sx = sourceNode.x + sourceNode.width / 2 + offsetX;
				const sy = sourceNode.y + sourceNode.height + offsetY;
				const tx = targetNode.x + targetNode.width / 2 + offsetX;
				const ty = targetNode.y + offsetY;
				const midY = (sy + ty) / 2;
				return (
					<path
						key={`${source}-${target}`}
						d={`M ${sx} ${sy} L ${sx} ${midY} L ${tx} ${midY} L ${tx} ${ty}`}
						fill="none"
					/>
				);
			})}
		</svg>
	);
}
